module.exports = __webpack_public_path__ + "static/media/double-next-table.710f64f8.svg";